import type { HeadingLevel } from './TextUnit';
import type { InlineVideoUnitData } from './useComponent';
import { CaptionText } from './CaptionText';
import styles from './InlineVideoUnit.module.css';

interface InlineVideoUnitProps {
  headingLevel?: HeadingLevel;
  hideHeading?: boolean;
  unit: InlineVideoUnitData;
}

function clampHeadingLevel(level: HeadingLevel | undefined): HeadingLevel {
  if (!level) {
    return 2;
  }

  return Math.min(4, Math.max(2, level)) as HeadingLevel;
}

export function InlineVideoUnit({
  headingLevel,
  hideHeading = false,
  unit,
}: InlineVideoUnitProps) {
  const HeadingTag = `h${clampHeadingLevel(headingLevel)}` as const;
  const visibleHeading = hideHeading
    ? null
    : unit.numberedHeading ?? unit.heading ?? null;

  return (
    <article className={styles.unit}>
      {visibleHeading ? (
        <HeadingTag className={styles.heading} id={unit.anchorId}>
          {visibleHeading}
        </HeadingTag>
      ) : null}
      <div className={styles.frameWrapper}>
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={styles.frame}
          src={unit.embedUrl}
          title={unit.title}
        />
      </div>
      {unit.caption ? (
        <p className={styles.caption}>
          <CaptionText text={unit.caption} />
        </p>
      ) : null}
    </article>
  );
}
